<template>
  <div class="t-container page">
    <a-card>
      <div slot="title">
        <h5 style="float: left;margin-top: 0.5rem;">Regions that you service</h5>
      </div>
      <a-row>
        <a-col :span="24">
          <div>
            <a-tabs
                :default-active-key="1"
                tab-position="left"
                @prevClick="callback"
                @nextClick="callback"
            >
              <a-tab-pane
                  v-for="region in regions"
                  :key="region.id"
                  :tab="region.name">
                <service-region-form
                    :from-region="region"
                    :to-regions="regions"
                >
                </service-region-form>
              </a-tab-pane>
            </a-tabs>
          </div>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import ServiceRegionForm from "../../components/form/ServiceRegion";

const regions = [
  {
    "id": 1,
    "name": "Auckland"
  },
  {
    "id": 2,
    "name": "Bay of Plenty"
  },
  {
    "id": 3,
    "name": "Canterbury"
  },
  {
    "id": 4,
    "name": "Gisborne"
  },
  {
    "id": 5,
    "name": "Hawkes Bay"
  },
  {
    "id": 6,
    "name": "Manawatu / Wanganui"
  },
  {
    "id": 7,
    "name": "Marlborough"
  },
  {
    "id": 8,
    "name": "Nelson / Tasman"
  },
  {
    "id": 9,
    "name": "Northland"
  },
  {
    "id": 10,
    "name": "Otago"
  },
  {
    "id": 11,
    "name": "Southland"
  },
  {
    "id": 12,
    "name": "Taranaki"
  },
  {
    "id": 14,
    "name": "Waikato"
  },
  {
    "id": 15,
    "name": "Wellington"
  },
  {
    "id": 16,
    "name": "West Coast"
  }
];

export default {
  name: "ServiceRegions",
  components: {
    ServiceRegionForm,
  },
  data() {
    return {
      regions,
    };
  },
  methods: {
    callback(val) {
      console.log(val);
    }
  },
}
</script>

<style scoped>

</style>
